import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutSegAllocDetailTable extends Layout {
    sourceSegAllocDetail: DataSource;
    tableSegAllocDetail: Table;
}
